import React, { useState } from 'react';
import { Card } from '../../../components/Card/Card';
import { AvatarUpload } from '../../../components/AvatarUpload/AvatarUpload';
import { patchCompany, Company } from '../../../model/company';
import { readBytesUrl } from '../../../util/util';
import { KeyValueTable } from '../../../components/KeyValueTable/KeyValueTable';
import { t } from '../../../locales/translate';
import { handleError } from '../../../model/notification';
import { Icon } from '../../../components/Icon/Icon';
import { orderPath } from '../../../routes';
import { history } from '../../../model/history';

interface Props {
  company: Company;
}

export function CompanyGeneralInfo({ company }: Props): JSX.Element {
  const [loading, setLoading] = useState(false);

  async function handleOnChange(e?: File): Promise<void> {
    setLoading(true);
    try {
      if (!e) {
        await patchCompany(company.id, {
          icon: null,
        });
      } else {
        const bytes = await readBytesUrl(e);
        await patchCompany(company.id, { icon: bytes });
      }
    } catch (e) {
      handleError(e);
    }
    setLoading(false);
  }

  return (
    <div className="company-details__general-info">
      <Card
        elevation={1}
        actions={
          company.merchClearingOrderId && (
            <Icon
              name="bank-notes"
              onClick={() => {
                history.push(orderPath(company.merchClearingOrderId || ''));
              }}
            />
          )
        }
      >
        <div className="company-details__avatar">
          <AvatarUpload
            image={company.icon ? company.icon.url : undefined}
            onChange={handleOnChange}
            loading={loading}
          />
        </div>
        <div className="company-details__details">
          <h1 className="company-details__name">{company.name}</h1>
          <KeyValueTable
            className="company-details__phone-email"
            displayEmpty={false}
            items={[
              { key: t.model.user.email, value: company.address.email },
              { key: t.model.user.phone, value: company.address.phone },
            ]}
          />
        </div>
      </Card>
    </div>
  );
}
